<template>
    <section class="container__ main" style="position: relative; margin: 0 auto" :style="{'background-color': localBlock.color, 'padding-top': localBlock.paddingTop + 'px', 'padding-bottom': localBlock.paddingBottom + 'px'}">

        <div style="position: absolute; top: 16px; right: 16px;z-index: 2" class="hovered">
            <v-btn icon @click="adder = true">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn icon @click="$emit('move_row_up')">
                <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn icon @click="$emit('move_row_down')">
                <v-icon>mdi-arrow-down</v-icon>
            </v-btn>

            <v-menu top left>
                <template v-slot:activator="{ on }">
                    <v-btn class="link-context-menu" v-on="on" icon  >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>

                </template>
                <v-list>

                    <v-list-item @click="$emit('copy_main_block')">
                        <v-list-item-title>Копировать</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="settings = true">
                        <v-list-item-title>Редактировать</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="$emit('block-delete')">
                        <v-list-item-title>Удалить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>

        <v-dialog
                v-model="settings"
                max-width="600px"
                scrollable
        >
            <links-block-settings v-model="block" @close-settings="settings = false"></links-block-settings>

        </v-dialog>

        <v-container style="position: relative; max-width: 1200px; margin: 0 auto">
            <v-row justify="center" >
                <v-col class="link-col" v-for="(link,index) in localBlock.links" :key="link.id" :cols="cols" style="position: relative">
                    <link-item :link="link" @move_block_right="move_block_right(index)" @move_block_left="move_block_left(index)" @copy_block="copy(index)" @delete-link="deleteLink(index)" @update-link="localBlock.links[index] = $event" ></link-item>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="adder" max-width="600px">
            <link-adder @create-link="addLink($event)" @close-adder="adder = false" ></link-adder>
        </v-dialog>

    </section>
</template>

<script>
    import LinkItem from "./LinksBlockLink"
    import LinkAdder from "./LinksBlockLinkAdder";
    import LinksBlockSettings from "./LinksBlockSettings";

    export default {
        props:["block"],
        components:{LinkItem, LinkAdder, LinksBlockSettings},
        name: "LinksBlock",
        data(){
            return {
                localBlock: this.block,
                adder: false,
                settings: false,
            }
        },
        computed: {
            cols () {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return 12
                    case 'sm': return 12
                    case 'md':
                        switch(this.block.links.length){
                            case 1: return 12
                            case 2: return 6
                            case 3: return 4
                            case 4: return 3
                        }
                        break
                    case 'lg':
                        switch(this.block.links.length){
                        case 1: return 12
                        case 2: return 6
                        case 3: return 4
                        case 4: return 3
                    }
                        break
                    case 'xl':
                        switch(this.block.links.length){
                            case 1: return 12
                            case 2: return 6
                            case 3: return 4
                            case 4: return 3
                        }
                        break
                }
                return false
            },
            maxId(){
                if(this.localBlock.links.length == 0){
                    return 0;
                } else {
                    return Math.max(...this.localBlock.links.map(kek => kek.id))
                }
            }
        },
        methods:{
            addLink(link){
                link.id = this.maxId + 1;
                this.localBlock.links.push(link)
            },
            closeAdder(){
                this.adder = false
            },
            deleteLink(index){
                if(this.block.links.length == 1){
                    this.$emit("block-delete")
                }
                this.block.links.splice(index, 1);
            },
            copy(index){
                let copy = Object.assign({},  this.block.links[index])
                copy.id=this.maxId + 1;
                this.block.links.push(copy);

            },
            move_block_left(index)
            {
                if(index === 0){return}
                let rows = [ this.block.links[index-1],  this.block.links[index]];
                this.block.links.splice(index-1, 2, rows[1], rows[0] );
            },
            move_block_right(index)
            {
                if(index === this.block.links.length-1){return}
                let rows = [ this.block.links[index],  this.block.links[index+1]];
                this.block.links.splice(index, 2, rows[1], rows[0] );

            },
        }
    }
</script>

<style scoped>
    .container{
        min-height: 250px;
    }

    .color-picker-closer{
        position: fixed;
        z-index: 99;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
    }

    .color-picker{
        position: absolute;
        z-index: 100;
        bottom: 0;
        right: 0
    }

    .hovered{
        opacity: 0;
        transition: 0.3s;
    }

    .main:hover .hovered{
        opacity: 1;
    }




</style>